<template>
  <div class="spotting-area-hero" :class="{'collapsed': collapseHero}">
    <div class="tw-container">
      <div class="spotting-area-hero__back-button-wrapper tw-flex items-center">
        <ds-button
          class="second-top-bar__link-item"
          :label="collapseHero ? '' : $t('spotting_areas_back', { title: spottingAreasLabel })"
          icon="arrow-left"
          variant="minimal"
          to="/spotting-areas"
          :style="collapseHero ? 'color: white; fill: white;' : 'margin-top: 15px; color: white; fill: white;'"
          v-tooltip="$t('spotting_areas_back', { title: spottingAreasLabel })"
          icon-fill-color="#ffffff"
        />
        <div class="spotting-area-hero__collapsed-info" v-if="collapseHero">
          <h4 class="spotting-area-hero__collapsed-title">
            {{ spottingArea.name }}
          </h4>
          <div class="spotting-area-hero__collapsed-description-row" v-if="spottingArea.description">
            <span class="spotting-area-hero__collapsed-description" v-html="truncatedDescription">
            </span>
          </div>
        </div>
      </div>

      <BasicHero
        class="!mt-0 !pt-2"
        show-expand-button
        :title="spottingArea.name"
        :subtitle="showSubTitle ? spottingArea.description : ''"
        :collapseHero="collapseHero"
      >
        <follow-button
          v-if="showingFollowButton"
          class="a-button" :model-value="isFollowed(spottingArea)"
          @update:modelValue="setFollowed(spottingArea, $event)"
        />

        <slot v-if="$slots.navigation" name="navigation">
        </slot>
      </BasicHero>
    </div>
  </div>
</template>

<script>
  import FollowButton from '../../components/FollowButton/FollowButton.vue'
  import BasicHero from '../BasicHero/BasicHero.vue'
  import TranslationsMixin from '../../util/TranslationsMixin'
  import SpottingAreaMixin from '../../util/SpottingAreaMixin'

  export default {
    props: {
      spottingArea: {},
      showSubTitle: {
        default: true,
        type: Boolean,
      },
      collapseHero: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      followedSpottingAreaIds () {
        return this.$store.state.user.profile.conceptSearches || []
      },
      conceptSearchIsFollowed () {
        const map = {}

        for (const id of this.followedSpottingAreaIds) {
          map[id] = true
        }

        return map
      },
      showingFollowButton () {
        return false
      },
      truncatedDescription () {
        if (!this.spottingArea?.description) return ''
        const maxLength = 80
        if (this.spottingArea.description.length <= maxLength) {
          return this.spottingArea.description
        }
        return this.spottingArea.description.substring(0, maxLength).trim() + '...'
      },
    },
    methods: {
      isFollowed () {
        return this.spottingAreaIsFollowed[this.spottingArea.id]
      },
      setFollowed (followed) {
        if (followed) {
          this.followSpottingArea(this.spottingArea.id)
        } else {
          this.unfollowSpottingArea(this.spottingArea.id)
        }
      },
    },
    mixins: [TranslationsMixin, SpottingAreaMixin],
    components: {
      BasicHero,
      FollowButton,
    },
  }
</script>

<style lang="scss">

  .spotting-area-hero__back-button-wrapper {
    transition: margin 0.3s ease-in-out;

    .second-top-bar__link-item {
      transition: margin 0.3s ease-in-out;
      flex-shrink: 0;
    }

    @media (max-width: 576px) {
      padding: 0 8px;
    }
  }

  .spotting-area-hero__collapsed-info {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    animation: spotting-area-fadeIn 0.3s ease-in-out;
    overflow: hidden;
    min-width: 0;

    @media (max-width: 576px) {
      margin-left: 6px;
    }
  }

  .spotting-area-hero__collapsed-title {
    color: white;
    font-size: 1.2rem;
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
      font-size: 1rem;
    }

    @media (max-width: 576px) {
      font-size: 0.9rem;
    }
  }

  .spotting-area-hero__collapsed-description-row {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;

    @media (max-width: 576px) {
      display: none;
    }
  }

  .spotting-area-hero__collapsed-description {
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.85rem;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 500px;

    @media (max-width: 992px) {
      max-width: 350px;
    }

    @media (max-width: 768px) {
      max-width: 200px;
      font-size: 0.8rem;
    }
  }

  @keyframes spotting-area-fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .button--minimal:hover .svg-icon path {
    fill: white !important;
  }

  .spotting-area-hero {
    background: var(--primary);
    z-index: 21;
    transition: all 0.3s ease-in-out;

    &.collapsed {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      box-shadow: 0 6px 5px -4px rgba(0, 0, 0, 0.5);

      .spotting-area-hero__back-button-wrapper {
        margin-top: 10px;

        @media (max-width: 576px) {
          margin-top: 8px;
        }
      }

      .basic-hero {
        padding-top: 0.5rem;
        padding-bottom: 0;

        .basic-hero__header {
          opacity: 0;
          max-height: 0;
          overflow: hidden;
          transform: translateY(-20px);
        }
      }
    }

    .container {
      margin: 0 auto;

      &.basic-hero__subtitle {
        margin: 0;
      }
    }

    .basic-hero {
      padding-top: 2.5rem;
      padding-bottom: 0;
      text-align: left;
      transition: padding 0.3s ease-in-out;

      @media (max-width: 768px) {
        padding-top: 1.5rem;
      }

      @media (max-width: 576px) {
        padding-top: 1rem;
      }

      .basic-hero__header {
        opacity: 1;
        max-height: 1000px;
        overflow: visible;
        transform: translateY(0);
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out, max-height 0.3s ease-in-out;
      }

      .basic-hero__slot {
        width: 100%;
        position: sticky;
        top: 70px;
        display: block !important;
        background: var(--primary);
        z-index: 19;
        margin-top: 0;
        margin-left: -10px;
        margin-right: -10px;
        padding-left: 10px;
        padding-right: 10px;
        transition: all 0.3s ease-in-out;

        @media (max-width: 768px) {
          top: 56px;
        }

        .basic-hero-nav-bar {
          background: transparent;
          justify-content: flex-start;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;

          scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            display: none;
          }

          .top-bar__links {
            display: flex;
            overflow-x: auto;
            overflow-y: hidden;
            justify-content: flex-start;
            align-items: baseline;
            flex-wrap: nowrap;
            gap: 0;

            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
              display: none;
            }

            .button {
              padding: 5px 12px 0;
              flex-shrink: 0;

              @media (max-width: 768px) {
                padding: 4px 8px 0;
              }

              @media (max-width: 576px) {
                padding: 4px 6px 0;
              }
            }

            :deep(.button__label) {
              color: white;
              text-transform: uppercase;
              white-space: nowrap;

              @media (max-width: 768px) {
                font-size: 0.75rem;
              }

              @media (max-width: 576px) {
                font-size: 0.7rem;
              }
            }

            .button--minimal:focus {
              // override !important in focus-state.scss
              box-shadow: none !important;
            }

            .second-top-bar__link-active {
              background-color: rgba(204, 204, 204, 0.1);
              color: white;
            }
          }
        }
      }
    }
  }

</style>
